// src/utils/models/contactModel.js

import { CLIENT_TYPES } from "./clientModel";

export const CONTACT_TYPES = {
  CLIENT: "client",
  COMMERCIAL: "commercial",
  EPC: "epc",
  SUPPLIER: "supplier",
};

export const CONTACT_TYPE_LABELS = {
  client: "Cliente",
  commercial: "Comercial",
  epc: "EPC",
  supplier: "Proveedor",
};

export const COMPANY_REQUIRED_TYPES = [
  CONTACT_TYPES.SUPPLIER,
];

export const COMPANY_ONLY_TYPES = [
  CONTACT_TYPES.SUPPLIER,
];

export const PERSON_TYPES = [
  CONTACT_TYPES.EPC,
  CONTACT_TYPES.COMMERCIAL,
];

export const createContact = (data) => ({
  id: "",

  contactType: data.contactType || CONTACT_TYPES.CLIENT,

  // Datos personales (para EPC, commercial, client individual)
  firstName: data.firstName || "",
  lastName: data.lastName || "",
  email: data.email || "",
  phone: data.phone || "",
  mobile: data.mobile || "",
  dni: data.dni || "",

  // Nombre de la persona de contacto (cliente empresa)
  contactName: data.contactName || "",

  // Datos profesionales (para EPC, commercial)
  position: data.position || "",
  department: data.department || "",

  // Empresa asociada
  companyId: data.companyId || "",
  companyName: data.companyName || "",

  // Datos fiscales de empresa (supplier, client company)
  companyTaxId: data.companyTaxId || "",
  companyIndustry: data.companyIndustry || "",
  companyWebsite: data.companyWebsite || "",

  // Persona de contacto del proveedor
  supplierContactName: data.supplierContactName || "",
  supplierContactPhone: data.supplierContactPhone || "",
  supplierContactEmail: data.supplierContactEmail || "",

  // Representante legal/apoderado (cliente empresa)
  representativeName: data.representativeName || "",
  representativePhone: data.representativePhone || "",
  representativeEmail: data.representativeEmail || "",
  representativeDni: data.representativeDni || "",

  // Dirección
  address: {
    street: data.address?.street || "",
    city: data.address?.city || "",
    state: data.address?.state || "",
    zipCode: data.address?.zipCode || "",
    country: data.address?.country || "España",
  },

  // Cliente
  clientType: data.clientType || CLIENT_TYPES.INDIVIDUAL,
  clientId: data.clientId || "",

  // 👇 NUEVOS CAMPOS 👇
  supplierId: data.supplierId || "",
  commercialId: data.commercialId || "",

  notes: data.notes || "",
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  createdBy: "",
  isActive: true,
});

export const contactSchema = {
  contactType: CONTACT_TYPES.CLIENT,
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  mobile: "",
  dni: "",
  contactName: "",
  position: "",
  department: "",
  companyId: "",
  companyName: "",
  companyTaxId: "",
  companyIndustry: "",
  companyWebsite: "",
  supplierContactName: "",
  supplierContactPhone: "",
  supplierContactEmail: "",
  representativeName: "",
  representativePhone: "",
  representativeEmail: "",
  representativeDni: "",
  address: {
    street: "",
    city: "",
    state: "",
    zipCode: "",
    country: "España",
  },
  clientType: CLIENT_TYPES.INDIVIDUAL,
  clientId: "",
  // 👇 NUEVOS CAMPOS 👇
  supplierId: "",
  commercialId: "",
  notes: "",
  isActive: true,
};